"use client"

import { motion, useReducedMotion } from "motion/react"

/**
 * Список дел, которые перестают быть вашими (05-copy.md, блок B).
 *
 * Движение здесь единственное на странице и оно несёт смысл: строка
 * вычёркивается на глазах читателя, и это ровно то, что продаёт блок.
 * Под prefers-reduced-motion черта стоит сразу, без анимации: сообщение
 * не зависит от движения, движение только показывает переход.
 */

const items: { task: string; instead: string }[] = [
  {
    task: "Выбрать, где всё это хостить",
    instead: "приложение живёт в вашем облаке, Минск или Франкфурт",
  },
  {
    task: "Настроить домен и сертификат",
    instead: "адрес на вашем домене и HTTPS включаем мы",
  },
  {
    task: "Не забыть про копии",
    instead: "копии данных лежат в отдельном хранилище",
  },
  {
    task: "Следить, хватает ли памяти",
    instead: "нагрузка и логи открыты вам на странице приложения",
  },
  {
    task: "Искать, кому написать, когда сломалось",
    instead: "пишете дежурному инженеру",
  },
  {
    task: "Решать, обновляться сегодня или подождать",
    instead: "обновляем, когда скажете вы, а не когда вышла новая версия",
  },
]

export default function HandoverList() {
  const reduce = useReducedMotion()

  return (
    <ul className="space-y-6">
      {items.map((item, index) => (
        <li key={item.task}>
          <span className="relative inline-block text-base font-medium text-gray-500 dark:text-white/45">
            <s className="no-underline">{item.task}</s>
            <motion.span
              aria-hidden="true"
              className="absolute inset-x-0 top-1/2 h-px origin-left bg-gray-400 dark:bg-white/40"
              initial={reduce ? false : { scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{
                duration: 0.45,
                delay: reduce ? 0 : index * 0.08,
                ease: [0.16, 1, 0.3, 1],
              }}
            />
          </span>
          <span className="mt-1 block text-base text-pretty text-slate-900 dark:text-white/85">
            {item.instead}
          </span>
        </li>
      ))}
    </ul>
  )
}
